import { API_ENDPOINTS } from '@/constants/api';
import { api } from '@/utils';

import type { CombinedTranscript } from '@/types/transcript';

export interface SummaryResponse {
    outcome: string;
    summary: string;
    tone: string;
}

export interface QuestionResponse {
    answer: string;
}

export type OpenAIResponse = SummaryResponse | QuestionResponse;

export interface OpenAIRequest {
    transcript: CombinedTranscript[];
    question?: string;
    requestType: 'summary' | 'question';
}

export const sendOpenAiRequest = async (request: OpenAIRequest): Promise<OpenAIResponse> => {
    const response = await api.post(API_ENDPOINTS.OPENAI_QUERY, {
        transcript: request.transcript,
        question: request.question,
        requestType: request.requestType,
    });

    return response.data;
};
